const scrollProps = {
  smooth: true,
  duration: 500,
  offset: -80,
};

export default scrollProps;
